<template>
  <component :is="subComponentName" :model="page"></component>
</template>
<script>
import NewsDetails from '../contentComponents/news/ContentType.NewsDetails.vue'
import VacancyDetails from '../contentComponents/Vacancy/ContentType.VacancyDetails.vue'
import Page from '../app/PageControl.vue'
import dataAccess from '../../services/service.data-access'
import { mapGetters } from 'vuex'
import pageBuilder from '../../services/pageBuilder.js'
export default {
  name: 'SubPageResolverPreview',
  data: () => ({ page: {} }),
  components: {
    NewsDetails,
    VacancyDetails,
    Page
  },
  props: {
    pageType: {
      type: String
    },
    idPage: {
      type: String
    }
  },
  watch: {
    subPage: function () {
      this.load()
    }
  },
  computed: {
    subComponentName: function () {
      return this.pageType
    },
    ...mapGetters({
      subPage: 'subPage'
    })
  },
  methods: {
    async load(url) {
      this.page = {}
      const urlKey = url || this.$attrs.subUrlKey
      const page = await dataAccess.getPage(urlKey)
      this.page = pageBuilder.buildTabPreview(page)
    }
  },
  created() {
    this.load()
  },
  async beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      this.load(to.params.subUrlKey)
    })
    next()
  }
}
</script>
